document.querySelectorAll('.offcanvas-menu__nav .accordion-title').forEach(item => {
  item.addEventListener('click', function(event) {
      // Get some useful info about the clicked element (optional)
      const itemText = event.target.innerText;  // The text of the navigation item
      const itemHref = event.target.href;      // The href of the clicked link

      // Track the custom event in Clarity
      clarity('set', 'customNavClick', {
          'itemText': itemText,
          'itemHref': itemHref
      });

      console.log('Custom Nav Click Tracked:', itemText, itemHref);
  });
});